import { lazy } from "react";

export const GetStartedAnimation = lazy(async () => {
    const { matches: prefersReducedMotion } = globalThis.matchMedia("(prefers-reduced-motion: reduce)");
    const { default: src } = prefersReducedMotion
        ? await import("./get-started-animation.motionless.svg")
        : await import("./get-started-animation.svg");
    return { default: () => <img src={src} alt="" /> };
});
